import React from 'react';

import { ActionIcon } from '@mantine/core';

function ClearButton({ isActive, onClear }) {
    if (!isActive) {
        return null;
    }

    return (
        <ActionIcon
            onClick={onClear}
            variant="subtle"
        >
            ×
        </ActionIcon>
    );
}

export default ClearButton;
